module.exports = __webpack_public_path__ + "img/img02@2x.46dc6c28.jpg";